import type { Section, SimpleHouse } from '../../types';

import { cache } from '../cache';
import { estClient } from './estClient';

export interface HouseWithSections {
  name: string;
  sections: {
    id: string;
    name: string;
  }[];
}

class HouseApi {
  getAll(): Promise<SimpleHouse[]> {
    return cache.get('houses', () =>
      estClient.get<SimpleHouse[]>('/api/house/all'),
    );
  }

  getAllWithSection(): Promise<HouseWithSections[]> {
    return cache.get('houses-with-section', () =>
      estClient.get<HouseWithSections[]>('/api/house/all_with_section'),
    );
  }

  getSections(houseId: string | number): Promise<Section[]> {
    return cache.get(`house-${houseId}-sections`, () =>
      estClient.get<Section[]>(`/api/house/${houseId}/sections/all`),
    );
  }
}

export const houseApi = new HouseApi();
